import { Ref, ref } from 'vue';
import { useStoreDataCloud } from '@/components/Cloud/Dashboard/useStoreData';
import { useStoreData } from '@/components/Common/useStoreData';
import {
  ObjectsMapper,
  OverviewHeaders,
  Subscriptions,
} from '@/components/Cloud/Hooks/cloud.all.types';

interface UseMatricesDataProps {
  headers: Ref<OverviewHeaders[]>;
  subscriptions: Ref<Subscriptions[]>;
}

export function useMatricesData({
  headers,
  subscriptions,
}: UseMatricesDataProps) {
  const { getDurationTime } = useStoreData();
  const { fetchReadMatricListDataForServices, getCurrentServices } =
    useStoreDataCloud();
  const subscriptionMatrices = ref<ObjectsMapper[]>([]);
  const filteredSubscriptionMatrices = ref<ObjectsMapper[]>([]);
  const getMatricesData = async (currentDurationTime: string) => {
    try {
      const matrices = await fetchReadMatricListDataForServices({
        headers: headers.value,
        iterateInstance: subscriptions.value,
        getDurationTime: getDurationTime.value,
      });

      subscriptionMatrices.value = matrices;

      filteredSubscriptionMatrices.value = matrices.filter((matric: any) =>
        getCurrentServices.value.includes(matric.serviceId),
      );
    } catch (err) {
      console.log('Failed to fetch matric data: ', err);
    }
  };

  const fetchMatrices = async () => {
    await [getMatricesData(getDurationTime.value)];
  };

  return {
    subscriptionMatrices,
    filteredSubscriptionMatrices,
    fetchMatrices,
  };
}
